import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import EmailIcon from '@material-ui/icons/Email'
import userProvider from '../../providers/user.provider'

const STORAGE_PREFIX = 'weestoryworld_verify_dismissed_'

export default function UserVerificationAlert() {
  const user = useSelector((state) => state.user)
  const storageKey = useMemo(
    () => (user && user.pk ? `${STORAGE_PREFIX}${user.pk}` : null),
    [user]
  )

  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === 'undefined' || !storageKey) return false
    return localStorage.getItem(storageKey) === '1'
  })

  const dismiss = useCallback(() => {
    if (storageKey) localStorage.setItem(storageKey, '1')
    setDismissed(true)
  }, [storageKey])

  const resendActivationLink = (e) => {
    e.preventDefault()
    if (user && user.email) userProvider.resendLink(user.email)
  }

  if (!user || dismissed) return null
  if (user.verified || user.membership) return null

  return (
    <Paper
      elevation={0}
      style={{
        marginBottom: 12,
        padding: '12px 44px 12px 16px',
        position: 'relative',
        backgroundColor: '#FFF3CD',
        borderLeft: '4px solid #9CD350',
        borderRadius: 4,
      }}
    >
      <Typography variant="body2" component="div" style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
        <EmailIcon fontSize="small" style={{ color: '#9CD350', marginTop: 1, flexShrink: 0 }} />
        <span>
          Please activate your account — check the link we sent to{' '}
          <b>{user.email}</b>.{' '}
          <a href="/#" onClick={resendActivationLink} style={{ color: '#6a9d25', fontWeight: 600 }}>
            Resend link
          </a>
        </span>
      </Typography>
      <IconButton
        aria-label="Dismiss"
        size="small"
        onClick={dismiss}
        style={{ position: 'absolute', right: 4, top: 4 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Paper>
  )
}
